import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Button,
  Row,
  Col,
  Form,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";

const sec = {
  borderLeft: "4px solid #3b82f6",
  paddingLeft: 12,
  marginBottom: 8,
  color: "#1e3a8a",
  fontWeight: 600,
  fontSize: "0.85rem",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
};
const block = {
  background: "#f8fafc",
  borderRadius: 8,
  padding: "12px 16px",
  marginBottom: 14,
};

function PromocionesWalmartCreate() {
  const { user } = useContext(AuthContext);
  const URL_PROMOCIONES_WALMART = process.env.REACT_APP_URL_PROMOCIONES_WALMART;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;

  const hoy = moment().format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState(null);
  const [descuento, setDescuento] = useState(0);
  const [tipoDescuento, setTipoDescuento] = useState("Porcentaje");
  const [fechaInicio, setFechaInicio] = useState(hoy);
  const [fechaFin, setFechaFin] = useState(hoy);
  const [marca, setMarca] = useState("NA");
  const [categoria, setCategoria] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    if (user.ventas_create) {
      axios
        .get(URL_ARTICULOS, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        })
        .then((res) => setArticulos(res.data))
        .catch(() => {
          Swal.fire({ icon: "error", title: "Error al cargar artículos" });
        });
    }
  }, []);

  const savePromocion = (e) => {
    e.preventDefault();
    if (!selectedArticulo) {
      Swal.fire({ icon: "warning", title: "Selecciona un artículo" });
      return;
    }
    setValidaBoton(false);
    axios
      .post(
        URL_PROMOCIONES_WALMART,
        {
          articulos: selectedArticulo._id,
          descuento,
          tipoDescuento,
          fechaInicio,
          fechaFin,
          marca,
          categoria,
          observaciones,
          is_active: "Si",
        },
        {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        }
      )
      .then(() => {
        Swal.fire({ icon: "success", title: "Promoción creada", timer: 1500, showConfirmButton: false });
        setTimeout(() => {
          window.location.href = "/ListadoPromocionesWalmart";
        }, 1600);
      })
      .catch((err) => {
        const msg = err.response?.data?.message || "Error al guardar";
        Swal.fire({ icon: "error", title: msg });
        setValidaBoton(true);
      });
  };

  if (!user.ventas_create) {
    return (
      <div>
        <Header />
        <br />
        <center>
          <h4>Acceso denegado</h4>
        </center>
      </div>
    );
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        <div className="card shadow-sm">
          {/* Toolbar */}
          <div
            className="card-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#fff",
              borderBottom: "1px solid #e2e8f0",
              padding: "12px 20px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: "1.1rem", fontWeight: 700, color: "#1e3a8a" }}>
                📣 Nueva Promoción Walmart
              </span>
              <span
                style={{
                  background: "#dbeafe",
                  color: "#1e3a8a",
                  borderRadius: 20,
                  padding: "3px 14px",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                }}
              >
                Crear
              </span>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <a href="/ListadoPromocionesWalmart">
                <Button size="sm" color="secondary" outline>
                  ← Regresar
                </Button>
              </a>
            </div>
          </div>

          <div className="card-body">
            <Form onSubmit={savePromocion}>
              {/* Artículo */}
              <div style={block}>
                <p style={sec}>📋 Artículo</p>
                <Autocomplete
                  fullWidth
                  options={articulos}
                  getOptionLabel={(opt) =>
                    opt.nombre ? `${opt.nombre} / ${opt.codigo || ""}` : ""
                  }
                  value={selectedArticulo}
                  onChange={(e, val) => setSelectedArticulo(val)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Buscar artículo"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              </div>

              {/* Detalles */}
              <div style={block}>
                <p style={sec}>📋 Detalles</p>
                <Row>
                  <Col md={2}>
                    <Label style={{ fontWeight: 600, fontSize: "0.8rem" }}>Descuento</Label>
                    <Input
                      type="number"
                      min={0}
                      step="0.01"
                      value={descuento}
                      onChange={(e) => setDescuento(e.target.value)}
                      bsSize="sm"
                    />
                  </Col>
                  <Col md={2}>
                    <Label style={{ fontWeight: 600, fontSize: "0.8rem" }}>Tipo Descuento</Label>
                    <Input
                      type="select"
                      value={tipoDescuento}
                      onChange={(e) => setTipoDescuento(e.target.value)}
                      bsSize="sm"
                    >
                      <option value="Porcentaje">Porcentaje</option>
                      <option value="Fijo">Fijo</option>
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label style={{ fontWeight: 600, fontSize: "0.8rem" }}>Fecha Inicio</Label>
                    <Input
                      type="date"
                      value={fechaInicio}
                      onChange={(e) => setFechaInicio(e.target.value)}
                      bsSize="sm"
                    />
                  </Col>
                  <Col md={2}>
                    <Label style={{ fontWeight: 600, fontSize: "0.8rem" }}>Fecha Fin</Label>
                    <Input
                      type="date"
                      value={fechaFin}
                      onChange={(e) => setFechaFin(e.target.value)}
                      bsSize="sm"
                    />
                  </Col>
                  <Col md={2}>
                    <Label style={{ fontWeight: 600, fontSize: "0.8rem" }}>Marca</Label>
                    <Input
                      type="text"
                      value={marca}
                      onChange={(e) => setMarca(e.target.value)}
                      bsSize="sm"
                    />
                  </Col>
                  <Col md={2}>
                    <Label style={{ fontWeight: 600, fontSize: "0.8rem" }}>Categoría</Label>
                    <Input
                      type="text"
                      value={categoria}
                      onChange={(e) => setCategoria(e.target.value)}
                      bsSize="sm"
                    />
                  </Col>
                </Row>
              </div>

              {/* Observaciones */}
              <div style={block}>
                <p style={sec}>📝 Observaciones</p>
                <Input
                  type="textarea"
                  rows={3}
                  value={observaciones}
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </div>

              {/* Buttons */}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <a href="/ListadoPromocionesWalmart">
                  <Button color="secondary" outline>
                    Regresar
                  </Button>
                </a>
                <Button color="primary" type="submit" disabled={!validaBoton}>
                  {validaBoton ? "Guardar" : <Spinner size="sm" />}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default PromocionesWalmartCreate;
